import { TicketActivity, ApplicationUserViewModel } from '../../models';

export class TicketActivityViewModel {
    public model: TicketActivity;
    public creationUser: ApplicationUserViewModel;
    public creationDate: string;
}